<template>
    <div class="select_product shipping">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Team Store</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Custom Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Basic Information</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Select Product</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Design</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Shipping</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">5</div>
                                <h5 class="mb-0">Publish</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="shipping_section pt_52">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="shipping_box">
                            <div class="row">
                                <div class="col-md-12">
                                    <h1 class="heading1 mb_6">Shipping</h1>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div
                                        class="shipping_address_box d-flex align-items-start active_border"
                                    >
                                        <img
                                            src="/maincss/images/checked_shipping.svg"
                                            alt=" "
                                        />
                                        <div class="shipping_content ml_14">
                                            <h5>Default Shipping Address</h5>
                                            <h6 style="font-size: 16px">
                                                Group Admin
                                            </h6>
                                            <p>
                                                Daisy Dukes 24367 Owyhee Court
                                                Rd Bldg 3, Rm 4 Meridian
                                            </p>
                                        </div>

                                        <div class="edit_shipping_address">
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_shipping.svg"
                                                    alt=""
                                            /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row add_more_address_row">
                                <div class="col-md-3">
                                    <div
                                        class="shipping_address_box d-flex align-items-start"
                                    >
                                        <div class="shipping_content ml_14">
                                            <h5>Coach/Team 1</h5>
                                            <h6>Group Admin</h6>
                                            <p>Dave Summer Basketball U13</p>
                                            <p>
                                                - Items will be delivered to
                                                Group Admin
                                            </p>
                                        </div>

                                        <div class="edit_shipping_address">
                                            <a
                                                href="#"
                                                data-toggle="modal"
                                                data-path="/myorder"
                                                data-target="#coach_team"
                                                class="coach_team_a_tag"
                                            >
                                                <img
                                                    src="/maincss/images/edit_shipping.svg"
                                                    alt=""
                                            /></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div
                                        class="shipping_address_box d-flex align-items-start"
                                    >
                                        <div class="shipping_content ml_14">
                                            <h5>Coach/Team 2</h5>
                                            <h6>Group Admin</h6>
                                            <p>Dave Summer Basketball U13</p>
                                            <p>
                                                - Items will be delivered to
                                                Group Admin
                                            </p>
                                        </div>

                                        <div class="edit_shipping_address">
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_shipping.svg"
                                                    alt=""
                                            /></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div
                                        class="shipping_address_box d-flex align-items-start"
                                    >
                                        <div class="shipping_content ml_14">
                                            <h5>Coach/Team 3</h5>
                                            <h6>Group Admin</h6>
                                            <p>Dave Summer Basketball U13</p>
                                            <p>
                                                - Items will be delivered to
                                                Group Admin
                                            </p>
                                        </div>

                                        <div class="edit_shipping_address">
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_shipping.svg"
                                                    alt=""
                                            /></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <a
                                        href="#"
                                        class="bg-white shipping_address_box active_border d-flex flex-column align-items-centre justify-content-centre add_new_address"
                                    >
                                        <div class="text-center m-auto">
                                            <img
                                                src="/maincss/images/add_more_brand.svg"
                                                alt=" "
                                                class="w-auto"
                                            />
                                            <p
                                                class="font_size_20 text_primary_blue mt_18 mb-0"
                                            >
                                                Add New Group Admin
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div
                                        class="buttons mt_52 ml-auto text-right"
                                    >
                                        <a
                                            href="/team/select-product"
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                                            >BACK</a
                                        >
                                        <a
                                            href="/team/publish"
                                            class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                            >Next</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Coach Modal Start -->

        <div
            class="modal coach_form_popup fade h-auto"
            id="coach_team"
            tabindex="-1"
            aria-labelledby="coach_team"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div class="coach_form">
                            <h3>Edit - Coach/Team 1</h3>
                            <form>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="Name"
                                                name="Name"
                                            />
                                            <label class="custome_space_form"
                                                >Name</label
                                            >
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <small
                                                class="form-text text-error text-left"
                                            >
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="Sport"
                                                name="Sport"
                                            />
                                            <label class="custome_space_form"
                                                >Sport</label
                                            >
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <small
                                                class="form-text text-error text-left"
                                            >
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="label-control2"
                                                >Coach/Team</label
                                            >
                                            <fieldset>
                                                <div
                                                    dir="auto"
                                                    class="v-select vs--single vs--searchable"
                                                    name="state"
                                                    data-vv-as="State"
                                                >
                                                    <div
                                                        id="vs3__combobox"
                                                        role="combobox"
                                                        aria-expanded="false"
                                                        aria-owns="vs3__listbox"
                                                        aria-label="Search for option"
                                                        class="vs__dropdown-toggle"
                                                    >
                                                        <div
                                                            class="vs__selected-options"
                                                        >
                                                            <span
                                                                class="vs__selected"
                                                            >
                                                                Coach/Team
                                                            </span>
                                                            <input
                                                                aria-autocomplete="list"
                                                                aria-labelledby="vs3__combobox"
                                                                aria-controls="vs3__listbox"
                                                                type="search"
                                                                autocomplete="off"
                                                                class="vs__search"
                                                            />
                                                        </div>
                                                        <div
                                                            class="vs__actions"
                                                        >
                                                            <button
                                                                type="button"
                                                                title="Clear Selected"
                                                                aria-label="Clear Selected"
                                                                class="vs__clear"
                                                                style=""
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="10"
                                                                    height="10"
                                                                >
                                                                    <path
                                                                        d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
                                                                    ></path>
                                                                </svg>
                                                            </button>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="14"
                                                                height="10"
                                                                role="presentation"
                                                                class="vs__open-indicator"
                                                            >
                                                                <path
                                                                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                                                                ></path>
                                                            </svg>
                                                            <div
                                                                class="vs__spinner"
                                                                style="
                                                                    display: none;
                                                                "
                                                            >
                                                                Loading...
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ul
                                                        id="vs3__listbox"
                                                        role="listbox"
                                                        style="
                                                            display: none;
                                                            visibility: hidden;
                                                        "
                                                    ></ul>
                                                </div>
                                                <small
                                                    class="form-text text-error text-left"
                                                    style="display: none"
                                                >
                                                </small>
                                            </fieldset>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="label-control2"
                                                >Group Admin</label
                                            >
                                            <fieldset>
                                                <div
                                                    dir="auto"
                                                    class="v-select vs--single vs--searchable"
                                                    name="state"
                                                    data-vv-as="State"
                                                >
                                                    <div
                                                        id="vs3__combobox"
                                                        role="combobox"
                                                        aria-expanded="false"
                                                        aria-owns="vs3__listbox"
                                                        aria-label="Search for option"
                                                        class="vs__dropdown-toggle"
                                                    >
                                                        <div
                                                            class="vs__selected-options"
                                                        >
                                                            <span
                                                                class="vs__selected"
                                                                >Type</span
                                                            >
                                                            <input
                                                                aria-autocomplete="list"
                                                                aria-labelledby="vs3__combobox"
                                                                aria-controls="vs3__listbox"
                                                                type="search"
                                                                autocomplete="off"
                                                                class="vs__search"
                                                            />
                                                        </div>
                                                        <div
                                                            class="vs__actions"
                                                        >
                                                            <button
                                                                type="button"
                                                                title="Clear Selected"
                                                                aria-label="Clear Selected"
                                                                class="vs__clear"
                                                                style=""
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="10"
                                                                    height="10"
                                                                >
                                                                    <path
                                                                        d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
                                                                    ></path>
                                                                </svg>
                                                            </button>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="14"
                                                                height="10"
                                                                role="presentation"
                                                                class="vs__open-indicator"
                                                            >
                                                                <path
                                                                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                                                                ></path>
                                                            </svg>
                                                            <div
                                                                class="vs__spinner"
                                                                style="
                                                                    display: none;
                                                                "
                                                            >
                                                                Loading...
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ul
                                                        id="vs3__listbox"
                                                        role="listbox"
                                                        style="
                                                            display: none;
                                                            visibility: hidden;
                                                        "
                                                    ></ul>
                                                </div>
                                                <small
                                                    class="form-text text-error text-left"
                                                    style="display: none"
                                                >
                                                </small>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>

                                <div class="items_will_be mt_36 ml_8">
                                    <label for="">
                                        <input type="checkbox" />
                                        Item will be delivered to Group Admin
                                    </label>
                                </div>

                                <div class="coach_form_btn text-center mt_48">
                                    <a
                                        href="#"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue mr_20"
                                        >Cancel</a
                                    >
                                    <a
                                        href="#"
                                        class="btn btn_orange bg_primary_orange text_white"
                                        >Save</a
                                    >
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Coach Modal End -->
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Shipping",
    /* eslint-enable */
    components: {},
    mounted() {
        document.body.classList.add("");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
